/* @flow */
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import * as React from 'react';
import { cloneDeep } from 'lodash';

import CurrentUser from 'auth/CurrentUser';
import ArchivedClassesList from './ArchivedClassesList';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import Fieldset from 'components/Fieldset';
import Legend from 'components/Legend';
import OwnedClassesList from './OwnedClassesList';
import classesDefaultsFragment from 'groups/fragments/classesDefaultsFragment.gql';
import Group from 'entities/Group';

type Props = {
  ownedGroups: Group[],
  archivedGroups: Group[],
  loading: boolean,
  refetch: () => void,
};

class OrganizeClassesView extends React.Component<Props> {
  render() {
    const { loading, archivedGroups, ownedGroups } = this.props;
    const canCreateGroups = CurrentUser.getUser().canCreateGroups();
    return (
      <div>
        <Fieldset>
          <Legend>
            Archived classes
            <p>Restore or reuse classes you’ve archived.</p>
          </Legend>
          {loading ? (
            <CenteredLoadingIndicator />
          ) : (
            <ArchivedClassesList
              archivedClasses={archivedGroups}
              canCreateGroups={canCreateGroups}
              onActionCompletion={this.props.refetch}
            />
          )}
        </Fieldset>
        <Fieldset>
          <Legend>
            Current classes
            <p>
              If your organization is part of a Remind School Plan or District Plan, you may see
              classes that were automatically added by your school’s database.
            </p>
          </Legend>
          {loading ? (
            <CenteredLoadingIndicator />
          ) : (
            <OwnedClassesList ownedClasses={ownedGroups} onActionCompletion={this.props.refetch} />
          )}
        </Fieldset>
      </div>
    );
  }
}

const withOwnedClasses = graphql(
  gql`
    ${classesDefaultsFragment}
    query AllOwnedClassesQuery {
      me {
        uuid
        archivedClasses: classes(classType: "archived") {
          ...classesDefaults
        }
        ownedClasses: classes(classType: "owned") {
          ...classesDefaults
        }
      }
    }
  `,
  {
    props: ({ data }) => {
      console.log(data);
      const { loading, me, refetch } = data;
      if (loading || !me) {
        return { loading, refetch };
      }

      const { archivedClasses, ownedClasses } = me;

      const archivedGroups = archivedClasses
        .filter(Boolean) // GraphQL returns null for unavailable values
        .map(group => Group.fromJSON(cloneDeep(group))); // clone to separate Apollo from Backbone data

      const ownedGroups = ownedClasses
        .filter(Boolean)
        .map(group => Group.fromJSON(cloneDeep(group)));

      return {
        ownedGroups,
        archivedGroups,
        refetch,
      };
    },
    options: { notifyOnNetworkStatusChange: true },
  }
);

export { OrganizeClassesView };
export default withOwnedClasses(OrganizeClassesView);
